import React, { useState } from 'react';
import { Box, Notification, NotificationType, Pagination } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { TODAY } from '@epi-constants/downloadReports';

import { TransactionsSelectRange } from '../TransactionsSelectRange';
import { TransactionsCalendarRange } from '../TransactionsCalendarRange';

import { BalanceCorrectionsTable } from './BalanceCorrectionsTable';
import { useBalanceCorrections } from './hooks/useBalanceCorrections';

export const BalanceCorrections = () => {
  const { t } = useTranslation();
  const { gray10 } = useTheme();
  const [showNotification, setShowNotification] = useState(true);
  const {
    reports,
    page,
    totalPages,
    isLoading,
    showCalendar,
    setShowCalendar,
    timePeriodType,
    handleChangePage,
    from,
    to,
    setFrom,
    setTo,
    setPage,
    setTimePeriodType
  } = useBalanceCorrections();

  const closeNotification = () => {
    setShowNotification(false);
  };

  const closeTimePeriod = () => {
    setShowCalendar(false);
  };

  return (
    <Box marginTop="40px">
      {showNotification && (
        <Notification
          text={t('containers.deposit_money.corrections_tab.info')}
          type={NotificationType.Info}
          onClose={closeNotification}
          id="balance-corrections-info"
        />
      )}
      <Box pb={5} borderBottom={`1px solid ${gray10}`} my={5}>
        <TransactionsSelectRange
          setPage={setPage}
          setShowCalendar={setShowCalendar}
          timePeriodType={timePeriodType}
          setTimePeriodType={setTimePeriodType}
          from={from}
          setFrom={setFrom}
          to={to}
          setTo={setTo}
        />
      </Box>
      {showCalendar && (
        <TransactionsCalendarRange
          isOpen={showCalendar}
          closeAction={closeTimePeriod}
          disabledCustomDates={{ after: TODAY }}
          from={from}
          to={to}
          setFrom={setFrom}
          setTo={setTo}
        />
      )}
      <BalanceCorrectionsTable
        correctionReports={reports}
        isLoading={isLoading}
      />
      <Box mt={5}>
        <Pagination
          prevBtnText={t('shared.pagination.previous')}
          nextBtnText={t('shared.pagination.next')}
          page={page}
          count={totalPages}
          onChangePage={handleChangePage}
        />
      </Box>
    </Box>
  );
};
